import { useState, useEffect } from "react";
import api from "../../services/api";
import DataTable from "react-data-table-component";
import Swal from 'sweetalert2';
import { faSquarePlus, faSquareMinus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil,} from "@fortawesome/free-solid-svg-icons";

import EditModal from "../ui/EditModal.js";


const paginationOptionsES = {
  rowsPerPageText: 'Filas por página',
  rangeSeparatorText: 'de',
  selectAllRowsItem: true,
  selectAllRowsItemText: 'Todos',
};

const AddComorbilidadesXPatologia = () => {
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [comorbilidadAEditar, setComorbilidadAEditar] = useState(null);
  const [IdPatologia, setIdPatologia] = useState("");
  const [IdComorbilidad, setIdComorbilidad] = useState("");
  const [allPatologias, setAllPatologias] = useState([]);
  const [allComorbilidades, setAllComorbilidades] = useState([]);
  const [comorbilidadesXPatologia, setComorbilidadesXPatologia] = useState([]);
  const [filtroEstado, setFiltroEstado] = useState("activas");
  const [mostrarDescripcion, setMostrarDescripcion] = useState({});

  useEffect(() => {
    getPatologias();
    getAllComorbilidades();
  }, []);

  useEffect(() => {
    if (IdPatologia !== "") {
      getComorbilidadesPorPatologia();
    }
  }, [IdPatologia]);

  const getPatologias = async () => {
    try {
      const response = await api.get(`/patologias`);
      const patologiasActivas = response.data.filter(p => p.estado === 1);
      setAllPatologias(patologiasActivas);
    } catch (error) {
      console.error("Error al obtener todas las patologías: " + error.message);
    }
  };

  const getAllComorbilidades = async () => {
    try {
      const response = await api.get(`/comorbilidadesAll`);
      const comorbilidadesActivas = response.data.filter(c => c.estado === 1);
      setAllComorbilidades(comorbilidadesActivas);
    } catch (error) {
      console.error("Error al obtener todas las comorbilidades:", error);
    }
  };

  const getComorbilidadesPorPatologia = async () => {
    try {
      const response = await api.get(`/comorbilidades/${IdPatologia}`);
      console.log("=== DATOS RECIBIDOS ===");
      console.log("Total registros:", response.data.length);
      response.data.forEach((item, index) => {
        console.log(`${index + 1}. ${item.Nombre}: estadoRelacion=${item.estadoRelacion} (tipo: ${typeof item.estadoRelacion}, Number: ${Number(item.estadoRelacion)})`);
      });
      setComorbilidadesXPatologia(response.data);
    } catch (error) {
      console.error("Error al obtener las comorbilidades por patología: " + error.message);
    }
  };

  const createComorbilidadPorPatologia = async (e) => {
    e.preventDefault();
    if (!IdPatologia || !IdComorbilidad) {
      return Swal.fire("Falta completar", "Debe seleccionar una patología y una comorbilidad.", "warning");
    }
    const yaExiste = comorbilidadesXPatologia.some(item => item.IdComorbilidad === parseInt(IdComorbilidad));
    if (yaExiste) {
      return Swal.fire("Duplicado", "Esta comorbilidad ya está asociada a la patología seleccionada.", "error");
    }
    try {
      const response = await api.post(`/comorbilidades/asociar`, {
        IdPatologia,
        IdComorbilidad,
      });
      if (response.status === 201 || response.status === 200) {
        await getComorbilidadesPorPatologia();
        Swal.fire("Éxito", "La comorbilidad fue asociada correctamente.", "success");
        setIdComorbilidad("");
      } else {
        Swal.fire("Error", "No se pudo crear la relación.", "error");
      }
    } catch (error) {
      console.error("Error al crear la relación:", error);
      Swal.fire("Error", "Ocurrió un error al guardar.", "error");
    }
  };

  const toggleEstadoComorbilidadPorPatologia = async (IdComorbilidad) => {
    try {
      console.log("🔄 Toggling comorbilidad:", IdComorbilidad, "Patología:", IdPatologia);
      const response = await api.put(`/comorbilidadPatToggleEstado`, {
        IdPatologia,
        IdComorbilidad,
      });
      console.log("✅ Respuesta del toggle:", response.data);
      await getComorbilidadesPorPatologia();
      Swal.fire("Éxito", "Estado actualizado.", "success");
    } catch (error) {
      console.error("Error al actualizar estado:", error);
      Swal.fire("Error", "No se pudo actualizar el estado.", "error");
    }
  };

  const actualizarComorbilidad = async (valores) => {
    try {
      await api.put(`/comorbilidades/${valores.IdComorbilidad}`, valores);
      Swal.fire("Actualizado", "La comorbilidad fue actualizada correctamente.", "success");
      setEditModalOpen(false);
      getComorbilidadesPorPatologia();
    } catch (error) {
      console.error("Error al actualizar comorbilidad:", error);
      Swal.fire("Error", "No se pudo actualizar la comorbilidad.", "error");
    }
  };

  const filtrarComorbilidades = () => {
    if (filtroEstado === "activas") {
      return comorbilidadesXPatologia.filter(c => Number(c.estadoRelacion) === 1);
    }
    if (filtroEstado === "inactivas") {
      return comorbilidadesXPatologia.filter(c => Number(c.estadoRelacion) === 0);
    }
    return comorbilidadesXPatologia;
  };

  const columnas = [
    {
      name: "Nombre",
      selector: (row) => row.Nombre,
      sortable: true,
      width: "15vw",
    },
    {
      name: "Descripción",
      cell: (row) => {
        const toggleDescripcion = () => {
          setMostrarDescripcion((prev) => ({
            ...prev,
            [row.IdComorbilidad]: !prev[row.IdComorbilidad],
          }));
        };

        const descripcion = row.Descripcion || "Sin descripción";
        const mostrarBoton = row.Descripcion && row.Descripcion.length > 50;

        const estiloCelda = {
          display: "flex",
          alignItems: "center",
          width: "30vw",
          maxHeight: mostrarDescripcion[row.IdComorbilidad] ? "none" : "40vh",
          overflow: mostrarDescripcion[row.IdComorbilidad] ? "visible" : "hidden",
        };

        const estiloContenido = {
          flex: 1,
          maxHeight: "40vh",
          textOverflow: mostrarDescripcion[row.IdComorbilidad] ? "clip" : "ellipsis",
          whiteSpace: mostrarDescripcion[row.IdComorbilidad] ? "normal" : "nowrap",
        };

        return (
          <div style={estiloCelda}>
            <div style={estiloContenido}>
              {!mostrarDescripcion[row.IdComorbilidad]
                ? descripcion.length > 50
                  ? descripcion.substring(0, 50) + "..."
                  : descripcion
                : descripcion}
            </div>
            {mostrarBoton && (
              <button
                className="button is-small is-light ml-2"
                onClick={(e) => {
                  e.preventDefault();
                  toggleDescripcion();
                }}
              >
                {mostrarDescripcion[row.IdComorbilidad] ? "Ver Menos" : "Ver Más"}
              </button>
            )}
          </div>
        );
      },
      sortable: true,
      width: "30vw",
    },
    {
     cell: (row) => (
      <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
        {/* Botón editar (primero) */}
        <button
          className="button is-small is-info"
          title="Editar"
          onClick={() => {
            setComorbilidadAEditar({
              IdComorbilidad: row.IdComorbilidad,
              Nombre: row.Nombre,
              Descripcion: row.Descripcion || "",
            });
            setEditModalOpen(true);
          }}
        >
          <FontAwesomeIcon icon={faPencil} />
        </button>

        {/* Botón activar/desactivar */}
        <FontAwesomeIcon
          icon={Number(row.estadoRelacion) === 1 ? faSquarePlus : faSquareMinus}
          style={{
            color: Number(row.estadoRelacion) === 1 ?  "#37ff00" : "#ff0000",
            cursor: "pointer",
          }}
          size="2xl"
          title={Number(row.estadoRelacion) === 1 ? "Activar" :  "Desactivar"}
          onClick={() => {
            if (IdPatologia) {
              toggleEstadoComorbilidadPorPatologia(row.IdComorbilidad);
            } else {
              Swal.fire("Error", "Debes seleccionar una patología primero.", "warning");
            }
          }}
        />
      </div>
    ),
    ignoreRowClick: true,
    button: true,
    width: "14vw",
  },
];
  const paginationOptionsES = {
    rowsPerPageText: "Filas por página",
    rangeSeparatorText: "de",
    selectAllRowsItem: true,
    selectAllRowsItemText: "Todos",
  };

  return (
    <div className="columns mt-5 is-centered">
      <div className="column is-half">
        <div className="notification is-primary">
          <strong>Creación de Comorbilidades por Patologías</strong>
        </div>

        <form onSubmit={createComorbilidadPorPatologia}>
          <div className="field">
            <label className="label required">Seleccionar Patología</label>
            <div className="control">
              <select
                className="select is-fullwidth"
                value={IdPatologia}
                required
                onChange={(e) => setIdPatologia(e.target.value)}
              >
                <option value="">Selecciona</option>
                {allPatologias.map((patologia) => (
                  <option key={patologia.IdPatologia} value={patologia.IdPatologia}>
                    {patologia.Nombre}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="field">
            <label className="label required">Seleccionar Comorbilidad</label>
            <div className="control">
              <select
                className="select is-fullwidth"
                value={IdComorbilidad}
                required
                onChange={(e) => setIdComorbilidad(e.target.value)}
              >
                <option value="">Selecciona</option>
                {allComorbilidades.map((comorbilidad) => (
                  <option key={comorbilidad.IdComorbilidad} value={comorbilidad.IdComorbilidad}>
                    {comorbilidad.Nombre}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="field mt-4">
            <button type="submit" className="button is-success">
              Guardar
            </button>
          </div>
        </form>

        <div style={{ marginTop: "1rem", marginBottom: "1rem" }}>
          {["todas", "activas", "inactivas"].map((estado) => (
            <button
              key={estado}
              onClick={() => setFiltroEstado(estado)}
              type="button"
              className={`button is-small ${
                filtroEstado === estado ? "is-primary" : "is-light"
              } mr-2`}
            >
              {estado.charAt(0).toUpperCase() + estado.slice(1)}
            </button>
          ))}
        </div>

        <div
          style={{
            width: "auto",
            left: "20vw",
            position: "absolute",
            border: "1px solid gray",
            borderRadius: "8px",
            padding: "8px",
          }}
        >
          <DataTable
            pagination
            paginationComponentOptions={paginationOptionsES}
            columns={columnas}
            data={filtrarComorbilidades()}
            dense={false}
          />
        </div>

        {editModalOpen && (
          <EditModal
            title="Editar Comorbilidad"
            initialValues={comorbilidadAEditar}
            fields={[
              { name: "Nombre", label: "Nombre", type: "text", required: true },
              { name: "Descripcion", label: "Descripción", type: "textarea", required: false },
            ]}
            onSubmit={actualizarComorbilidad}
            onClose={() => setEditModalOpen(false)}
          />
        )}
      </div>
    </div>
  );
};

export default AddComorbilidadesXPatologia;